import { FleetIncidentsScreen } from "@src/features/patriot-tools";

export default FleetIncidentsScreen;
